// src/api/userApi.js
import apiClient from './apiConfig';

const businessLogicApi = {
    Script_0: (data: any, campaignId: any) => {
        return apiClient.post(`campaign/${campaignId}/task/`, data);
    },
    Script_110: (data: any, campaignId?: any) => {
        return apiClient.post(`campaign/${campaignId}/task/`, data);
    },
    Script_210: (data: any, campaignId?: any) => {
        return apiClient.post(`campaign/${campaignId}/task/`, data);
    },
    Script_310: (data: any, campaignId?: any) => {
        return apiClient.post(`campaign/${campaignId}/task/`, data);
    },
    GetData110: (campaignId: number) => {
        return apiClient.get(`campaign/results_110/${campaignId}`)
    },
    GetData210: (campaignId: number) => {
        return apiClient.get(`campaign/results_210/${campaignId}`)
    },
    GetData310: (campaignId: number) => {
        return apiClient.get(`campaign/results_310/${campaignId}`)
    },
    CreateCampaign: (data: any) => {
        return apiClient.post('campaign/', data);
    },
    GetCampaigns: () => {
        return apiClient.get('campaign/')
    },
    GetCampaign: (campaignId: number) =>{
        return apiClient.get(`campaign?id=${campaignId}`)
    },
    DeleteCampaign: (data: number[]) => {
        return apiClient.post('campaign/delete/', data)
    },
    GetPosition: () => {
        return apiClient.get('campaign/positions/')
    },
    GetLevel: () => {
        return apiClient.get('campaign/experience_levels/')
    },
    StoreKeyword: (data: any, campaignId: any) => {
        return apiClient.post(`campaign/${campaignId}/campaign_input/`, data);
    },
    StoreEvaluate: (data: any, campaignId: any) => {
        return apiClient.post(`campaign/${campaignId}/profile_evaluation/`, data);
    }
};

export default businessLogicApi;
